module.exports = __webpack_public_path__ + "media/images/front/centres/corporate_office_castello-9fa9030e3d29b5b221c7372e840fd178.jpg";